export default {
  保存: "保存",
  取消: "取消",
  确认: "确认",
  删除: "删除",
  编辑: "编辑",
  新增: "新增",
  搜索: "搜索",
  查询: "查询",
  重置: "重置",
  展开: "展开",
  收起: "收起",
  是: "是",
  否: "否",
  操作: "操作",
  查看: "查看",
  关闭: "关闭",
  暂存: "暂存",
  提交: "提交",
  点击选择供应商: "点击选择供应商",
  点击上传: "点击上传",
  文件上传失败: "文件上传失败",
};
